import { render, staticRenderFns } from "./geometry.vue?vue&type=template&id=d2640ffc&"
import script from "./geometry.vue?vue&type=script&lang=js&"
export * from "./geometry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports